const data={
    bannerList:[//轮播
        {
            bannerid:"",
            imgUrl:require('assets/images/about/contact/banner_one.png'),
            jumpUrl:"",
        }
    ],
   
    businessConsulting:[//业务咨询
        // {
        //     region:"西南区域",//区域
        //     header:require('assets/images/about/contact/header_zxj.png'),//头像
        //     name:"钟兴娟",//名字
        //     position:"销售总监",//职位
        //     phone:"152 2370 7112",//电话
        //     code:require('assets/images/about/contact/code_zxj.jpg'),//微信名片二维码
        // },
        // {
        //     region:"西北区域",//区域
        //     header:require('assets/images/about/contact/header_hl.png'),//头像
        //     name:"何  礼",//名字
        //     position:"区域总监",//职位
        //     phone:"157 3059 6496",//电话
        //     code:require('assets/images/about/contact/code_hl.png'),//微信名片二维码
        // },
        // {
        //     region:"华南区域",//区域
        //     header:require('assets/images/about/contact/header_zy.png'),//头像
        //     name:"周  燕",//名字
        //     position:"区域总监",//职位
        //     phone:"186 0236 2961",//电话
        //     code:require('assets/images/about/contact/code_zy.png'),//微信名片二维码
        // },
        {
            region:"华东区域",//区域
            header:require('assets/images/about/contact/header_zh.png'),//头像
            name:"曾  虎",//名字
            position:"区域总监",//职位
            phone:"178 2373 5848",//电话
            code:require('assets/images/about/contact/code_zh.jpg'),//微信名片二维码
        },
    ],
}

export default data;
